import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourceCitationMainComponent } from './source-citation-main/source-citation-main.component';
import { SourceCitationEditorComponent } from './source-citation-editor/source-citation-editor.component';
import { FormsModule } from '@angular/forms';
import { CommonComponentModule } from '../common.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [SourceCitationMainComponent, SourceCitationEditorComponent],
  imports: [
    CommonModule,
    FormsModule,             
    CommonComponentModule,
    SharedModule
  ]
})
export class SourceCitationModule { }

// translation loader moved to SharedModule